export function normalizeReviewResponse(response) {
  if (!response || response.failed) throw new Error('Unable to load timesheet');
  const lists = ['staffList', 'casualList', 'labourList'];
  // All-department responses may be grouped or contain three employee lists.
  const groups = Array.isArray(response)
    ? (response.some(item => item && lists.some(key => Object.prototype.hasOwnProperty.call(item, key))) ? response : [{ staffList: response }])
    : [response];
  return groups.reduce((sources, group) => {
    if (!group || typeof group !== 'object') throw new Error('Invalid timesheet response');
    lists.forEach(listName => {
      const list = group[listName];
      if (list != null && !Array.isArray(list)) throw new Error('Invalid timesheet response');
      const staffList = (list || []).map(item => {
        if (!item || typeof item !== 'object') throw new Error('Invalid timesheet record');
        // Record departments are independent of allocation details.
        const record = {};
        ['name', 'staffName', 'staffId', 'staffCode', 'staffNo', 'code', 'id', 'department', 'deptName', 'staffDepartment', 'startTime', 'endTime'].forEach(key => { record[key] = item[key]; });
        record.staffListHours = item[`${listName}Hours`];
        return record;
      });
      sources.push({ department: group.department, staffList });
    });
    return sources;
  }, []);
}
